<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>

import DataServices from '@/core/DataServices'
import formEdit from './add'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Create Reason",
      mode: 'add',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      }
    }
  },
  async mounted () {
    // console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editReport_reason' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? ' Edit Reason' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_REASON);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
      this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    }

    else if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
    else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }

  },
  methods: {
    backToList() {
    this.$router.push({ path: '/admin/list-reason' });
    },
    async saveData(params) {
      console.log("paramsfuntion.....",params,this.mode)
      var uid = this.$store.getters.user
      if(this.mode === 'add'){
        console.log("co vo khong ")
        let objects_reason = {
          'type': params.type,
          'rank': params.rank,
          'active': params.active,
          'updated_by': uid,
        }
        console.log("created_at",objects_reason)
        this.$apollo.mutate({
          mutation: DataServices.insertData('report_reason'),
          variables: {
            objects: objects_reason
          }
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            var lang = ["en","ko","vi"];
            var returning = res.data[Object.keys(res.data)].returning[0];
            var reason_id = returning.id;

            console.log("iddddd",reason_id)
            var objects_reason_lang = {}
            for ( var i = 0 ; i < lang.length; i++ ) {
              if (lang[i] == 'en'){
                objects_reason_lang = {
                  'name':params.name_en,
                  'lang':lang[i],
                  'report_reason_id':reason_id,
                  'plain_name':this.$commonFuction.SkipVN(params.name_en),
                }
              }
              if (lang[i] == 'ko'){
                objects_reason_lang = {
                  'name':params.name_ko,
                  'lang':lang[i],
                  'report_reason_id':reason_id,
                  'plain_name':this.$commonFuction.SkipVN(params.name_ko),
                }
              }
              if (lang[i] == 'vi'){
                objects_reason_lang = {
                  'name':params.name_vi,
                  'lang':lang[i],
                  'report_reason_id':reason_id,
                  'plain_name':this.$commonFuction.SkipVN(params.name_vi),
                }
              }
              await this.$apollo.mutate({
                mutation: DataServices.insertData('report_reason_lang'),
                variables: {
                  objects: objects_reason_lang
                }
              })
            }
          }

        }).then(() => {
          this.redirectEdit();
        });
      }
      if(this.mode === 'edit'){
        console.log("modeee_edit",this.mode)
        let objects_reason = {
          'type': params.type,
          'rank': params.rank,
          'active': params.active,
          'updated_by': uid,
        }
        let variables = {
          'data_update': objects_reason,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        };
        this.$apollo.mutate({
          mutation: DataServices.updateData('report_reason'),
          variables: variables
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            // var returning = res.data[Object.keys(res.data)].returning[0];
            var reason_id = this.models.id;
            console.log("iddd_guideee",reason_id)
            var objects_reason_lang = {}
            var objects = {}
            var lang = ["en","ko","vi"];
            for (var i = 0; i < lang.length; i++) {
              if (lang[i] == 'en') {
                objects = {
                  'name': params.name_en,
                  'lang': lang[i],
                  'plain_name':this.$commonFuction.SkipVN(params.name_en),
                }

                objects_reason_lang = {
                  'data_update': objects,
                  'where_key': {
                    'report_reason_id': {'_eq': this.models.id},
                    'lang': {'_eq':lang[i]}
                  }
                };
              }
              if (lang[i] == 'ko') {
                objects = {
                  'name': params.name_ko,
                  'lang': lang[i],
                  'plain_name':this.$commonFuction.SkipVN(params.name_ko),
                }

                objects_reason_lang = {
                  'data_update': objects,
                  'where_key': {
                    'report_reason_id': {'_eq': this.models.id},
                    'lang': {'_eq':lang[i]}
                  }
                };
              }
              if (lang[i] == 'vi') {
                objects = {
                  'name': params.name_vi,
                  'lang': lang[i],
                  'plain_name':this.$commonFuction.SkipVN(params.name_vi),
                }

                objects_reason_lang = {
                  'data_update': objects,
                  'where_key': {
                    'report_reason_id': {'_eq': this.models.id},
                    'lang': {'_eq':lang[i]}
                  }
                };
              }
              console.log("objects_guide_lang",objects_reason_lang)
              await this.$apollo.mutate({
                mutation: DataServices.updateData('report_reason_lang'),
                variables: objects_reason_lang
              })

            }
          }

        }).then(() => {
          this.redirectEdit();
          // this.$commonFuction.is_loading(false);
          // this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thành công', life: 3000 })
        });
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      var router_back = {path: '/admin/list-reason'};
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save success', life: 3000 })
      that.$router.push(router_back);
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('report_reason',{"fields" : "id active created_at updated_at rank type "}),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },

  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  // .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 0px 24px 0px 24px;
    .p-field{
      .p-col-fixed { width: 300px; margin: 0;}
      .p-col-width{width:100% !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }


  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0; padding-top: 0px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>